module.exports =  {
    ALL_DAMAGE : 1,
    ALL_SUPPORTER_DAMAGE : 2, //use for supports TAP_DAMAGE,
    TAP_DAMAGE : 3,
    ALL_GOLD :  4
};
